import FornecedorService from "../../services/FornecedorService";
import SelectFornecedor from "./SelectFornecedor";

export default class SelectFornecedorByAreaAtuacao extends SelectFornecedor {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);
    }

    componentDidUpdate(nextProps) {
        super.componentDidUpdate(nextProps);
        if (nextProps.idAreaAtuacao !== this.props.idAreaAtuacao) {
            this.getOptions();
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        if (this.props.idAreaAtuacao) {
            FornecedorService.getForComboByAreaAtuacao(this.props.idAreaAtuacao, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}